import { createAction } from 'redux-actions';
import type { PlaygroundSubsection } from '../../types/store';

export const initializePlayground = createAction(
  'STUDIO.PLAYGROUND_INITIALIZE',
  (subsection: PlaygroundSubsection) => ({ subsection })
);

export const pullDrawingsTabStatusSuccess = createAction(
  'STUDIO.PULL_DRAWINGS_TAB_STATUS_SUCCESS',
  (isDrawingsTabVisible: boolean) => ({ isDrawingsTabVisible })
);

export const pullDrawingsTabStatusFailure = createAction(
  'STUDIO.PULL_DRAWINGS_TAB_STATUS_FAILURE',
  () => ({})
);

export const pullDrawingsTabStatus = createAction(`STUDIO.PULL_DRAWINGS_TAB_STATUS`, () => ({}));

export const navigateToWixel = createAction(`STUDIO.NAVIGATE_TO_WIXEL`, () => ({}));
